import styled from '@emotion/styled';

export const SignatureAnnotationImageOverlayer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	background: rgba(23, 23, 23, 0.1019607843);
	z-index: 9999;
	height: calc(100% + 1px);
	width: calc(100% + 1px);
`;

export const SignatureAnnotationImage = styled.img(
	{
		height: 'auto',
		width: 'auto',
		position: 'absolute',
		left: '1px',
		top: '1px',
	},
	props => ({
		maxWidth: props.width + 'px',
		maxHeight: props.height + 'px',
		width: props.width + 'px',
		height: props.height + 'px',
	})
);
